import { useQuery } from '@tanstack/react-query'
import { getAgendaSubscriptionService } from '@/services/subscriptions'

export const agendaSubscriptionQueryKey = (agendaId: string) => ['agendas', agendaId, 'subscription']

export const useAgendaSubscription = (agendaId: string) =>
  useQuery({
    queryKey: agendaSubscriptionQueryKey(agendaId),
    queryFn: () => getAgendaSubscriptionService(agendaId),
  })
